// Merge the archived Tixr block (event_dashboard_past_events.detail_data.tixr,
// written by scripts/backfill-tixr-crossover-detail.js) into the per-tier and
// per-day maps that processPastEventDetail builds from the Universe detail.
//
// Only crossover rows (source 'universe+tixr') carry detail_data.tixr. The
// header sold/revenue are NOT touched here: the caller already adds
// tixr_sold / tixr_revenue to them and its Universe count (ticketItemsSold)
// excludes Tixr, so adding tiers and days here does not double count.
//
// Tixr arrays are in the old {day, data:[{rateId, value, baseValue, allInValue}]}
// shape (what the original Tixr-only backfill produced). They are read directly
// and never mixed into the Universe arrays, so the Universe format sniffing in
// the caller is unaffected. Maps are mutated in place; the merged rate list is
// returned.
export function mergeTixrDetail(maps, tixr) {
  const {
    rates, tierSales, dailySales, dailyRevenue, dailyBaseRevenue, dailyAllInRevenue,
    tierRevenue, tierBaseRevenue, tierAllInRevenue,
  } = maps;
  if (!tixr || !Array.isArray(tixr.rates) || !tixr.rates.length) return { rates, added: 0 };

  const baseSort = rates.reduce((m, r) => Math.max(m, Number(r.sortIndex) || 0), 0) + 1;
  const nameById = {};
  const tixrRates = tixr.rates.map((r, i) => {
    nameById[r.id] = r.name;
    if (!tierSales[r.name]) {
      tierSales[r.name] = {
        sold: 0, dates: [], sortIndex: baseSort + (Number(r.sortIndex) || i),
        available: 0, maxQuantity: 0, isAvailable: false,
        displayPrice: r.displayPrice, price: Number(r.price) || 0,
      };
      tierRevenue[r.name] = 0; tierBaseRevenue[r.name] = 0; tierAllInRevenue[r.name] = 0;
    }
    return { id: r.id, name: r.name, price: Number(r.price) || 0, displayPrice: r.displayPrice, maxQuantity: 0, sortIndex: baseSort + (Number(r.sortIndex) || i), source: 'tixr' };
  });

  for (const day of tixr.ticketsByDate || []) {
    if (!day || !day.day || !Array.isArray(day.data)) continue;
    if (dailySales[day.day] == null) dailySales[day.day] = 0;
    for (const d of day.data) {
      const name = nameById[d.rateId];
      if (!name || !tierSales[name]) continue;
      const n = Number(d.value) || 0;
      tierSales[name].sold += n;
      tierSales[name].dates.push({ date: day.day, count: n });
      dailySales[day.day] += n;
    }
  }
  for (const day of tixr.salesByDate || []) {
    if (!day || !day.day || !Array.isArray(day.data)) continue;
    if (dailyRevenue[day.day] == null) dailyRevenue[day.day] = 0;
    if (dailyBaseRevenue[day.day] == null) dailyBaseRevenue[day.day] = 0;
    if (dailyAllInRevenue[day.day] == null) dailyAllInRevenue[day.day] = 0;
    for (const d of day.data) {
      const name = nameById[d.rateId];
      if (!name) continue;
      const rev = Number(d.value) || 0;
      const base = Number(d.baseValue ?? d.value) || 0;
      const allIn = Number(d.allInValue ?? d.value) || 0;
      if (tierRevenue[name] !== undefined) {
        tierRevenue[name] += rev; tierBaseRevenue[name] += base; tierAllInRevenue[name] += allIn;
      }
      dailyRevenue[day.day] += rev; dailyBaseRevenue[day.day] += base; dailyAllInRevenue[day.day] += allIn;
    }
  }
  return { rates: [...rates, ...tixrRates], added: tixrRates.length };
}
